import React, { useState } from "react";
import { Link, useNavigate } from "react-router";
import logo from '../images/logo.jpeg';
const Sidebar = () => {
  // Track which submenu is open
  const [openMenu, setOpenMenu] = useState(null);
  const toggleMenu = (menu) => {
    setOpenMenu(openMenu === menu ? null : menu);
  };
  let nav=useNavigate();
  function doLogout(event)
  {
    window.ulogin="";
    window.uname="";
    window.utype="";
    window.utoken="";
    localStorage.setItem("token","");
    nav("/");
  }
  return (
    <>
      {/* DESKTOP SIDEBAR */}
      <div style={{backgroundColor:'#5E17EB',width:'220px',height: "100vh", overflowY: "auto",flexShrink: 0 }} className="text-white d-none d-md-block">
        <div className="text-center mt-2">
          <Link to="/admin/" ><img src={logo} style={{width:'50px'}} /></Link>                    
        </div>
        <ul className="nav flex-column p-2">
          {/* Profile with submenu */}
          <li className="nav-item">
            <Link className="sidebar-link" to="/admin/dashboard" style={linkStyle}>
              <i className="fa-solid fa-dashboard"></i>&nbsp;Dashboard
            </Link>
          </li>
          <li className="nav-item">
            <Link className="sidebar-link" to="/admin/facilities" style={linkStyle}>
              <i className="fa-solid fa-building"></i>&nbsp;Facilities
            </Link>
          </li>
          <li className="nav-item">
            <Link className="sidebar-link" to="/admin/customers" style={linkStyle}>
              <i className="fa-solid fa-users"></i>&nbsp;Customers
            </Link>
          </li>
          <li className="nav-item">
            <Link className="sidebar-link text-danger" to="/admin/oldcustomers" style={linkStyle}>
              <i className="fa-solid text-danger fa-users"></i>&nbsp;Old Customers
            </Link>
          </li>
          <li className="nav-item">
            <Link className="sidebar-link" to="/admin/resources" style={linkStyle}>
              <i className="fa-solid fa-boxes"></i>&nbsp;Resources
            </Link>
          </li>
          <li className="nav-item">
            <Link className="sidebar-link" to="/admin/plans" style={linkStyle}>
              <i className="fa-solid fa-clipboard-list"></i>&nbsp;Plans
            </Link>
          </li>
          <li className="nav-item">
            <Link className="sidebar-link" to="/admin/membership" style={linkStyle}>
              <i className="fa-solid fa-id-card"></i>&nbsp;Membership
            </Link>
          </li>    
          <li className="nav-item">
            <div style={linkStyle} onClick={() => toggleMenu("invoices")}>
              <i className="fa-solid fa-file-invoice"></i>&nbsp;Invoices <span>{openMenu === "invoices" ? "-" : "+"}</span>
            </div>
            {openMenu === "invoices" && (
              <div className="submenu">
                <Link style={submenuStyle} to="/admin/pendinginvoices"><i className="fa-solid fa-hourglass-half"></i>&nbsp;Pending Invoices</Link>
                <Link style={submenuStyle} to="/admin/taxinvoices"><i className="fa-solid fa-file-invoice-dollar"></i>&nbsp;Tax Invoices</Link>
                <Link style={submenuStyle} to="/admin/simpleinvoices"><i className="fa-solid fa-receipt"></i>&nbsp;Simple Invoices</Link>
              </div>
            )}
          </li>
          <li className="nav-item">
            <Link className="sidebar-link" to="/admin/payments" style={linkStyle}>
              <i className="fa-solid fa-credit-card"></i>&nbsp;Payments
            </Link>
          </li> 
          {/* Settings with submenu */}
          <li className="nav-item">
            <div style={linkStyle} onClick={() => toggleMenu("reports")}>
              <i className="fa-solid fa-chart-bar"></i>&nbsp;Reports <span>{openMenu === "reports" ? "-" : "+"}</span>
            </div>

            {openMenu === "reports" && (
              <div className="submenu">
                <Link style={submenuStyle} to="/admin/rptdues"><i className="fa-solid fa-bell"></i>&nbsp;Payment Dues</Link>
                <Link style={submenuStyle} to="/admin/monthlydues"><i className="fa-solid fa-bell"></i>&nbsp;Monthly Dues</Link>                
                <Link style={submenuStyle} to="/admin/rptnewjoins"><i className="fa-solid fa-user-plus"></i>&nbsp;New Joinings</Link>
                <Link style={submenuStyle} to="/admin/rptrendue"><i className="fa-solid fa-rotate-right"></i>&nbsp;Renewal Due</Link>
                <Link style={submenuStyle} to="/admin/rptrenexpired"><i className="fa-solid fa-circle-xmark"></i>&nbsp;Renewal Expired</Link>                
              </div>
            )}
          </li>
          <li className="nav-item">
            <Link className="sidebar-link" to="/admin/messages" style={linkStyle}>
              <i className="fa-solid fa-message"></i>&nbsp;Send Message
            </Link>
          </li>
          <li className="nav-item">
            <Link className="sidebar-link" to="/admin/ledgers" style={linkStyle}>
              <i className="fa-solid fa-book"></i>&nbsp;General Ledger
            </Link>            
          </li>
          <li className="nav-item">
            <Link className="sidebar-link" to="/admin/paymentledger" style={linkStyle}>
              <i className="fa-solid fa-book"></i>&nbsp;Payment Ledger
            </Link>            
          </li>
          <li className="nav-item">
            <Link className="sidebar-link" to="/admin/accountheads" style={linkStyle}>
              <i className="fa-solid fa-file-signature"></i>&nbsp;Account Heads
            </Link>
          </li>
          <li className="nav-item">
            <div style={linkStyle1} onClick={() => toggleMenu("virtual")}>
              <i className="fa-solid fa-file-invoice"></i>&nbsp;Virtual Office <span>{openMenu === "virtual" ? "-" : "+"}</span>
            </div>
            {openMenu === "virtual" && (
              <div className="submenu">
                <Link style={submenuStyle1} to="/admin/virtualinvoices"><i className="fa-solid fa-hourglass-half"></i>&nbsp;Virtual Invoices</Link>
                <Link style={submenuStyle1} to="/admin/virtualclients"><i className="fa-solid fa-file-invoice-dollar"></i>&nbsp;Virtual Clients</Link>                
              </div>
            )}
          </li>
          <li className="nav-item">
            <div style={linkStyle1} onClick={() => toggleMenu("instant")}>
              <i className="fa-solid fa-file-invoice"></i>&nbsp;Instant Booking <span>{openMenu === "instant" ? "-" : "+"}</span>
            </div>
            {openMenu === "instant" && (
              <div className="submenu">
                <Link style={submenuStyle1} to="/admin/instantinvoices"><i className="fa-solid fa-hourglass-half"></i>&nbsp;Instant Booking</Link>
                <Link style={submenuStyle1} to="/admin/instantclients"><i className="fa-solid fa-file-invoice-dollar"></i>&nbsp;Instant Clients</Link>                
              </div>
            )}
          </li>
          <li className="nav-item">
            <div style={linkStyle1} onClick={() => toggleMenu("meeting")}>
              <i className="fa-solid fa-file-invoice"></i>&nbsp;Meeting Rooms <span>{openMenu === "meeting" ? "-" : "+"}</span>
            </div>
            {openMenu === "meeting" && (
              <div className="submenu">
                <Link style={submenuStyle1} to="/admin/meetingrooms"><i className="fa-solid fa-hourglass-half"></i>&nbsp;Meeting Rooms</Link>
                <Link style={submenuStyle1} to="/admin/meetinginvoices"><i className="fa-solid fa-hourglass-half"></i>&nbsp;Meeting Invoices</Link>
                <Link style={submenuStyle1} to="/admin/meetingclients"><i className="fa-solid fa-file-invoice-dollar"></i>&nbsp;Meeting Clients</Link>                
              </div>
            )}
          </li>
          <li className="nav-item">
            <Link className="sidebar-link" to="/admin/password" style={linkStyle}>
              <i className="fa-solid fa-key"></i>&nbsp;Password
            </Link>
          </li>
          <li className="nav-item">
            <Link className="sidebar-link" to="/admin/users" style={linkStyle}>
              <i className="fa-solid fa-user"></i>&nbsp;Users
            </Link>
          </li>   
          {/* Logout */}
          <li className="nav-item">
            <div className="sidebar-link" onClick={doLogout} style={linkStyle}>
              <i className="fa-solid fa-right-from-bracket"></i>&nbsp;Logout
            </div>
          </li>
        </ul>
      </div>

      {/* MOBILE OFFCANVAS */}
      <div className="offcanvas offcanvas-start" id="mobileSidebar" style={{width:'50%',backgroundColor:'#5E17EB'}}>
        <div className="offcanvas-header">
          <h5 className="text-white">InstaaOffice</h5>
          <button className="btn-close" data-bs-dismiss="offcanvas"></button>
        </div>
        <div className="offcanvas-body">
          <ul className="nav flex-column">
            <Link className="nav-link text-white" to="/admin/facilities"><i className="fa-solid fa-building"></i>&nbsp;Facilities</Link>
            <Link className="nav-link text-white" to="/admin/customers"><i className="fa-solid fa-users"></i>&nbsp;Customers</Link>
            <Link className="nav-link text-white" to="/admin/resources"><i className="fa-solid fa-boxes"></i>&nbsp;Resources</Link>
            <Link className="nav-link text-white" to="/admin/plans"><i className="fa-solid fa-clipboard-list"></i>&nbsp;Plans</Link>
            <Link className="nav-link text-white" to="/admin/memberships"><i className="fa-solid fa-id-card"></i>&nbsp;Memberships</Link>
            <Link className="nav-link text-white" to="/admin/meetingrooms"><i className="fa-solid fa-chair"></i>&nbsp;Meeting Rooms</Link>
            <Link className="nav-link text-white" to="/admin/users"><i className="fa-solid fa-user"></i>&nbsp;Users</Link>
            <div>
              <div className="nav-link text-white" onClick={() => toggleMenu("invoices")}>
                <i className="fa-solid fa-file-invoice"></i> Invoices &#10149;
              </div>
              {openMenu === "invoices" && (
                <div>
                  <Link className="nav-link ms-3 text-white" to="/admin/pendinginvoices"><i className="fa-solid fa-hourglass-half"></i> Pending Invoices</Link>
                  <Link className="nav-link ms-3 text-white" to="/admin/taxinvoices"><i className="fa-solid fa-file-invoice-dollar"></i> Tax Invoices</Link>
                  <Link className="nav-link ms-3 text-white" to="/admin/simpleinvoices"><i className="fa-solid fa-receipt"></i> Simple Invoices</Link>
                </div>
              )}
            </div>
            <Link className="nav-link text-white" to="/admin/payments"><i className="fa-solid fa-credit-card"></i> Payments</Link>            
            {/* Reuse the submenu state */}
            <div>
              <div className="nav-link text-white" onClick={() => toggleMenu("reports")}>
                <i className="fa-solid fa-chart-bar"></i> Reports &#10149;
              </div>
              {openMenu === "reports" && (
                <div>
                  <Link className="nav-link ms-3 text-white" to="/admin/rptdues"><i className="fa-solid fa-bell"></i> Payment Dues</Link>
                  <Link className="nav-link ms-3 text-white" to="/admin/monthlydues"><i className="fa-solid fa-bell"></i> Monthly Dues</Link>
                  <Link className="nav-link ms-3 text-white" to="/admin/rptnewjoins"><i className="fa-solid fa-user-plus"></i> New Joinings</Link>
                  <Link className="nav-link ms-3 text-white" to="/admin/rptrendue"><i className="fa-solid fa-rotate-right"></i> Renewal Due</Link>
                  <Link className="nav-link ms-3 text-white" to="/admin/rptrenexpired"><i className="fa-solid fa-circle-xmark"></i> Renewal Expired</Link>
                </div>
              )}
            </div>
            <Link className="nav-link text-white" to="/admin/messages"><i className="fa-solid fa-message"></i> Messages</Link>
            <Link className="nav-link text-white" to="/admin/ledgers"><i className="fa-solid fa-book"></i> General Ledger</Link>
            <Link className="nav-link text-white" to="/admin/paymentledger"><i className="fa-solid fa-book"></i> Payment Ledger</Link>
            <Link className="nav-link text-white" to="/admin/accountheads"><i className="fa-solid fa-file-signature"></i> Account Heads</Link>
            <Link className="nav-link text-white" to="/admin/password"><i className="fa-solid fa-key"></i> Password</Link>
            <div onClick={doLogout} className="nav-link text-white"><i className="fa-solid fa-right-from-bracket"></i> Logout</div>            
          </ul>
        </div>
      </div>
    </>
  );
};

// Inline styles (Bootstrap + custom)
const linkStyle = {
  padding: "10px 15px",
  display: "flex",  
  alignItems: "center",
  color: "white",
  cursor: "pointer",
  textDecoration: "none",
};

const submenuStyle = {
  paddingLeft: "35px",
  color: "#ddd",
  display: "block",
  paddingTop: "5px",
  paddingBottom: "5px",
  textDecoration: "none",
};
const linkStyle1 = {
  padding: "10px 15px",
  display: "flex",  
  alignItems: "center",
  color: "#00E5FF",
  cursor: "pointer",
  textDecoration: "none",
};

const submenuStyle1 = {
  paddingLeft: "35px",
  color: "#00E5FF",
  display: "block",
  paddingTop: "5px",
  paddingBottom: "5px",
  textDecoration: "none",
};

export default Sidebar;
